import { AuthenticationContext, adalGetToken, withAdalLogin } from "react-adal";

// required for Json Web Token (JWT) authorization
const adalConfig = {
  tenant: "d6faa5f9-0ae2-4033-8c01-30048a38deeb",
  clientId: "164ffded-5f9d-45b9-8198-cf359c90c0f6",
  redirectUri: `${window.location.port ? 'http' : 'https'}://${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }`,
  popUp: true,
  postLogoutRedirectUri:
    typeof window !== 'undefined' &&
    window &&
    window.location.href.split('?')[0].split('#')[0],
  extraQueryParameter: "domain_hint=PNNL.onmicrosoft.com",
  endpoints: {
    api: "https://PNNL.onmicrosoft.com/164ffded-5f9d-45b9-8198-cf359c90c0f6"
  },
  cacheLocation: "localStorage"
};

export const authContext = new AuthenticationContext(adalConfig);

export const getToken = () => adalGetToken(authContext, adalConfig.clientId);

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);